import { Card, CardContent, List, Box, Grid, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Breadcrumbs, Autocomplete, TextField, Tooltip, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Collapse, Paper } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { TableSortLabel } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ConvertDate, GetErrorMessageFromResponse, GetTime, UTCToCurrentTimeZone, getLastTwelveMonths, getMonthNumberFromName } from '../common/commonFunction';
import Navbar from '../components/Navbar';
import Loader from '../components/common components/Loader';
import { UserRequestListService } from '../services/UserRequestListService';
import { NavLink } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { userStore } from '../store/store';
import ShowNotes from '../components/ShowNotes';
import InfoIcon from '@mui/icons-material/Info';
import ShowItemFormData from '../components/modelPopup/ShowItemFormData';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useSnackBar } from '../components/context/snackbar-context';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import ApprovedIcon from "../assets/icon/Approved.png";
import DeniedIcon from "../assets/icon/Denied.png";

const HistoricalRequests = () => {
    const [requestIdSearch, setRequestIdSearch] = useState("");
    const [isLoading, setIsloading] = useState(true);
    const [selectedH_RequestNotes, SetSelectedH_RequestNotes] = useState<any>([]);
    const [OpenShowNotePopup, SetOpenShowNotePopup] = useState(false);
    const [historicalRequests, setHistoricalRequests] = React.useState([]);
    const [filteredHistoricalRequests, setFilteredHistoricalRequests] = React.useState([]);
    const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>({});
    const [visibleCount, setVisibleCount] = useState(50);
    const [sortDesc, setSortDesc] = useState(true);
    const handleExpandClick = (requestId: string) => {
        setExpandedRows((prev) => ({ ...prev, [requestId]: !prev[requestId] }));
    };
    const uStore: any = userStore();
    const [selectedItemFormDetails, SetSelectedItemFormDetails] = useState<any>([]);
    const [OpenShowItemDetailsPopup, SetOpenShowItemDetailsPopup] = useState(false);
    const [uniqueCreatedBy, setUniqueCreatedBy] = useState<any>([]);
    const [uniqueBehalfUserName, setUniqueBehalfUserName] = useState<any>([]);
    const [createdByFilters, setCreatedByFilters] = useState<any>([]);
    const [behalfUserNameFilters, setBehalfUserNameFilters] = useState<any>([]);
    const [uniqueItemType, setUniqueItemType] = useState<any>([]);
    const [itemTypeFilters, setItemTypeFilters] = useState<any>([]);
    const [dateRange, setDateRange] = useState<{ start: dayjs.Dayjs | null, end: dayjs.Dayjs | null }>({ start: null, end: null });


    // Reset visibleCount to 50 on any filter change
    const createdByHandler = (event: any, selectedCreatedBy: string[]) => {
        setIsloading(true);
        setCreatedByFilters(selectedCreatedBy);
        setVisibleCount(50);
    };

    const behalfUserNameHandler = (event: any, selectedBehalfUserName: string[]) => {
        setIsloading(true);
        setBehalfUserNameFilters(selectedBehalfUserName);
        setVisibleCount(50);
    };

    const itemTypeHandler = (event: any, selectedItemType: string[]) => {
        setIsloading(true);
        setItemTypeFilters(selectedItemType);
        setVisibleCount(50);
    };

    // Reset visibleCount to 50 on date change
    const handleDateRangeChange = (newRange: { start: dayjs.Dayjs | null, end: dayjs.Dayjs | null }) => {
        setDateRange(newRange);
        setVisibleCount(50);
    };

    const getHistoricalRequest = async () => {
        setFilteredHistoricalRequests([]);
        let res = await UserRequestListService.GetAllHistoricalRequestList(uStore.getUser().userEmail);
        if (res.data) {
            setHistoricalRequests(res.data.data);

            const uniqueCreatedByValues = [];
            const seen = new Set();
            for (const item of res.data.data) {
                if (!seen.has(item.createdUserName)) {
                    uniqueCreatedByValues.push(item.createdUserName);
                    seen.add(item.createdUserName);
                }
            }
            setUniqueCreatedBy(uniqueCreatedByValues.sort());
            const uniqueBehalfUserNameValues: any[] = [];
            const seenUsers = new Set();
            for (const item of res.data.data) {
                if (item.behalfUserName != null && item.behalfUserName != "") {
                    if (!seenUsers.has(item.behalfUserName)) {
                        uniqueBehalfUserNameValues.push(item.behalfUserName);
                        seenUsers.add(item.behalfUserName);
                    }
                }
            }
            setUniqueBehalfUserName(uniqueBehalfUserNameValues.sort());

            const uniqueItemTypeValues: any[] = [];
            const seenItemType = new Set();
            for (const item of res.data.data) {
                for (const request of item.items) {
                if (request.description != null && request.description != "") {
                    if (!seenItemType.has(request.description)) {
                    uniqueItemTypeValues.push(request.description);
                    seenItemType.add(request.description);
                    }
                }
                }
            }
            setUniqueItemType(uniqueItemTypeValues.sort());
            setIsloading(false);
            let res_data = res.data.data;
            if (res_data && res_data.length > 0) {
                setFilteredHistoricalRequests(res_data);
            }
        }
    }

    const filterRequests = () => {
        let filteredRequests = filteredHistoricalRequests;
        const filters: ((request: any) => boolean)[] = [];

        if (createdByFilters && createdByFilters.length > 0) {
            filters.push((request) => createdByFilters.includes(request.createdUserName));
        }

        if (behalfUserNameFilters && behalfUserNameFilters.length > 0) {
            filters.push((request) => behalfUserNameFilters.includes(request.behalfUserName));
        }

        if (itemTypeFilters && itemTypeFilters.length > 0) {
            filters.push((request) => {
                return request.items.some((item: any) => {
                    return itemTypeFilters.includes(item.description);
                })
            })
        }

        if (dateRange.start || dateRange.end) {
            let start: Date | null = null;
            let end: Date | null = null;
            if (dateRange.start) start = dateRange.start.startOf('day').toDate();
            if (dateRange.end) end = dateRange.end.endOf('day').toDate();
            
            filters.push((request) => {
                const reqDate = new Date(ConvertDate(request.createdDate));
                if (start && end) {
                    return reqDate >= start && reqDate <= end;
                } else if (start) {
                    return reqDate >= start;
                } else if (end) {
                    return reqDate <= end;
                }
                return false;
            });
        }

        filteredRequests = filters.reduce(
            (acc, filter) => acc.filter(filter),
            historicalRequests
        );
        setFilteredHistoricalRequests(filteredRequests);
        setIsloading(false);
    };
    
    useEffect(() => {
    setIsloading(true);
    filterRequests();
    }, [createdByFilters, behalfUserNameFilters, itemTypeFilters, dateRange, historicalRequests]);

    useEffect(() => {
        setIsloading(true);
        getHistoricalRequest();
    }, []);

    const handleCloseShowNotePopup = (isShowPopup: boolean) => {
        SetOpenShowNotePopup(isShowPopup);
    }

    return (
        <>
            <div className='breadcumDiv'>
                {
                    uStore.getUser().role === "Administrator" || uStore.getUser().role === "HR" ?
                        (<Breadcrumbs
                            separator={<ArrowForwardIosIcon />}
                            aria-label="breadcrumb"
                        >
                            <NavLink to="/pending-request" title="Pending Request">
                                Pending Request
                            </NavLink>
                            <span className="active-breadcumb">Historical Request</span>
                        </Breadcrumbs>) :
                        (<Breadcrumbs
                            separator={<ArrowForwardIosIcon />}
                            aria-label="breadcrumb"
                        >
                            <NavLink to="/search" title=" Make A Request">
                                Make A Request
                            </NavLink>
                            <NavLink to="/pending-request" title="Pending Request">
                                Pending Request
                            </NavLink>
                            <span className="active-breadcumb">Historical Request</span>
                        </Breadcrumbs>)
                }

            </div>
            <Navbar title="Historical Request" />
            <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(5, 1fr)',
                    gap: '10px',
                    padding: '20px',
                    backgroundColor: '#f0f0f0',
                    }}>
                        <TextField
                            label="Request ID"
                            value={requestIdSearch}
                            onChange={e => setRequestIdSearch(e.target.value.replace(/[^0-9]/g, ""))}
                            sx={{ flex: 1, minWidth: '120px', fontSize: '1rem' }}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Autocomplete
                        multiple={true}
                        options={ uniqueCreatedBy }
                        getOptionLabel={(option: string) => option}
                        renderInput={(params) => <TextField {...params} label="Requested By" />}
                        sx={{
                            flex: 1,
                            minWidth: '200px',
                            fontSize: '1rem',
                        }}
                        onChange={createdByHandler}
                        value={createdByFilters}
                        ></Autocomplete>
                        <Autocomplete
                        multiple={true}
                        options={ uniqueBehalfUserName }
                        getOptionLabel={(option: string) => option}
                        renderInput={(params) => <TextField {...params} label="On Behalf Of" />}
                        sx={{
                            flex: 1,
                            minWidth: '200px',
                            fontSize: '1rem', 
                        }}
                        onChange={behalfUserNameHandler}
                        value={behalfUserNameFilters}
                        ></Autocomplete>
                        <Autocomplete
                            multiple={true}
                            options={ uniqueItemType }
                            getOptionLabel={(option: string) => option}
                            renderInput={(params) => <TextField {...params} label="Item Description" />}
                            sx={{
                                flex: 1,
                                minWidth: '200px',
                                fontSize: '1rem',
                            }}
                            onChange={itemTypeHandler}
                        ></Autocomplete>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <DatePicker
                                    label="Start Date"
                                    value={dateRange.start}
                                    onChange={(newValue) => {
                                        handleDateRangeChange({ ...dateRange, start: newValue ?? null });
                                    }}
                                    slotProps={{ textField: { sx: { minWidth: '150px', fontSize: '1rem', m: 0 } } }}
                                />
                                <IconButton
                                    aria-label="Clear start date"
                                    onClick={() => handleDateRangeChange({ ...dateRange, start: null })}
                                    disabled={!dateRange.start}
                                    size="small"
                                    sx={{ color: 'red', p: 0.5 }}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                                <DatePicker
                                    label="End Date"
                                    value={dateRange.end}
                                    onChange={(newValue) => {
                                        handleDateRangeChange({ ...dateRange, end: newValue ?? null });
                                    }}
                                    slotProps={{ textField: { sx: { minWidth: '150px', fontSize: '1rem', m: 0 } } }}
                                />
                                <IconButton
                                    aria-label="Clear end date"
                                    onClick={() => handleDateRangeChange({ ...dateRange, end: null })}
                                    disabled={!dateRange.end}
                                    size="small"
                                    sx={{ color: 'red', p: 0.5 }}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        </LocalizationProvider>
                    </div>
            <Card
                sx={{
                    mt: 3,
                    p: 2,
                    // minWidth: "100%",
                    // maxWidth: "100%",
                    width: "100%",
                    textAlign: "start",
                    boxShadow: "none",
                }}
            >
                <CardContent>
                    {
                        isLoading ? (
                            <Loader />
                        ) : (
                            <div style={{ width: '100%', overflowX: 'auto' }}>
                                {filteredHistoricalRequests && filteredHistoricalRequests.length > 0 ? (
                                    <>
                                        <TableContainer component={Paper}>
                                            <Table style={{ minWidth: 650 }} aria-label="historical requests table">
                                                <TableHead>
                                                    <TableRow style={{ background: '#f5f5f5' }}>
                                                        <TableCell>
                                                            <TableSortLabel
                                                                active={true}
                                                                direction={sortDesc ? 'desc' : 'asc'}
                                                                onClick={() => setSortDesc((prev) => !prev)}
                                                            >
                                                                Request ID
                                                            </TableSortLabel>
                                                        </TableCell>
                                                        <TableCell>Requested By</TableCell>
                                                        <TableCell>Requested Date</TableCell>
                                                        <TableCell>Item Categories</TableCell>
                                                        <TableCell>Status</TableCell>
                                                        <TableCell>On Behalf Of</TableCell>
                                                        <TableCell>Notes</TableCell>
                                                        <TableCell />
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {filteredHistoricalRequests
                                                        .filter((req: any) =>
                                                            !requestIdSearch || req.id.toString().includes(requestIdSearch)
                                                        )
                                                        .slice()
                                                        .sort((a: any, b: any) => sortDesc ? b.id - a.id : a.id - b.id)
                                                        .slice(0, visibleCount)
                                                        .map((list: any) => {
                                                        const hasBehalf = !!list.behalfUserName;
                                                        const hasNotes = list.request_Notes && list.request_Notes.length > 0;
                                                        return (
                                                            <React.Fragment key={list.id}>
                                                                <TableRow hover style={{ background: '#fff' }}>
                                                                    <TableCell>{list.id}</TableCell>
                                                                    <TableCell>{list.createdUserName}</TableCell>
                                                                    <TableCell>{ConvertDate(list.createdDate)} @ {GetTime(list.createdDate)}</TableCell>
                                                                    <TableCell>{Array.from(new Set(list.items.map((item: any) => item.itemSubCategory))).join(', ')}</TableCell>
                                                                    <TableCell>
                                                                        {(() => {
                                                                            // Determine the most severe status among items: Denied > Pending > Approved
                                                                            let status = list.status;
                                                                            if (status === 'Pending') {
                                                                                return <span><b>Status:</b> Pending</span>;
                                                                            } else if (status === 'Approved') {
                                                                                return (
                                                                                    <span style={{ color: 'green', fontWeight: 600 }}>
                                                                                        <img className='ApprovedDeniedIcon' src={ApprovedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Approved
                                                                                    </span>
                                                                                );
                                                                            } else if (status === 'Denied') {
                                                                                return (
                                                                                    <span style={{ color: 'red', fontWeight: 600 }}>
                                                                                        <img className='ApprovedDeniedIcon' src={DeniedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Denied
                                                                                    </span>
                                                                                );
                                                                            }
                                                                            return null;
                                                                        })()}
                                                                    </TableCell>
                                                                    <TableCell>{hasBehalf ? list.behalfUserName : ''}</TableCell>
                                                                    <TableCell>
                                                                        {hasNotes ? (
                                                                            <Tooltip
                                                                                title={<span style={{ whiteSpace: 'pre-line', fontSize: '1.25rem', padding: 8, display: 'block', lineHeight: 1.5 }}>{list.request_Notes.map((n: any) => n.note || n).join('\n')}</span>}
                                                                                placement="top"
                                                                                arrow
                                                                                PopperProps={{
                                                                                    modifiers: [
                                                                                        {
                                                                                            name: 'offset',
                                                                                            options: {
                                                                                                offset: [0, 8],
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                                    sx: { '& .MuiTooltip-tooltip': { maxWidth: 400, padding: 2 } }
                                                                                }}
                                                                            >
                                                                                <span>
                                                                                    <InfoIcon style={{ color: '#1976d2', verticalAlign: 'middle', cursor: 'default' }} />
                                                                                </span>
                                                                            </Tooltip>
                                                                        ) : ''}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <IconButton
                                                                            aria-label="expand row"
                                                                            size="small"
                                                                            onClick={() => handleExpandClick(list.id)}
                                                                        >
                                                                            {expandedRows[list.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                                        <Collapse in={expandedRows[list.id]} timeout="auto" unmountOnExit>
                                                                            <Box margin={2}>
                                                                                <Table size="small" aria-label="items">
                                                                                    <TableHead>
                                                                                        <TableRow>
                                                                                            <TableCell>Item ID</TableCell>
                                                                                            <TableCell>Item Description</TableCell>
                                                                                            {list.items.some((item: any) => item.itemSubCategory === "Employee Life Cycle") ? (
                                                                                                <TableCell>Employee Name</TableCell>
                                                                                            ) : null}
                                                                                            <TableCell>Status</TableCell>
                                                                                            <TableCell>Denied Reason</TableCell>
                                                                                            <TableCell>Details</TableCell>
                                                                                        </TableRow>
                                                                                    </TableHead>
                                                                                    <TableBody>
                                                                                        {list.items.map((item: any) => {
                                                                                            const hasDeniedReason = item.status === 'Denied' && item.deniedReason;
                                                                                            return (
                                                                                                <TableRow key={item.requestItemID}>
                                                                                                    <TableCell>{item.requestItemID}</TableCell>
                                                                                                    <TableCell>{item.description}</TableCell>
                                                                                                    {list.items.some((itm: any) => itm.itemSubCategory === "Employee Life Cycle") ? (
                                                                                                        <TableCell>
                                                                                                            {item.itemSubCategory === "Employee Life Cycle" ? (() => {
                                                                                                                let details: any = {};
                                                                                                                try {
                                                                                                                    details = JSON.parse(item.formDataWithTitle);
                                                                                                                } catch {}
                                                                                                                if (typeof details === 'object' && details !== null) {
                                                                                                                    if (details["Employee Name"]) {
                                                                                                                        return details["Employee Name"];
                                                                                                                    }
                                                                                                                }
                                                                                                                return "N/A";
                                                                                                            })() : ""}
                                                                                                        </TableCell>
                                                                                                    ) : null}
                                                                                                    <TableCell>
                                                                                                        {item.status === 'Pending' && <span><b>Status:</b> Pending</span>}
                                                                                                        {item.status === 'Approved' && (
                                                                                                            <span style={{ color: 'green', fontWeight: 600 }}>
                                                                                                                <img className='ApprovedDeniedIcon' src={ApprovedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Approved
                                                                                                            </span>
                                                                                                        )}
                                                                                                        {item.status === 'Denied' && (
                                                                                                            <span style={{ color: 'red', fontWeight: 600 }}>
                                                                                                                <img className='ApprovedDeniedIcon' src={DeniedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Denied
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                    <TableCell>
                                                                                                        {hasDeniedReason ? (
                                                                                                            <Tooltip
                                                                                                                title={<span style={{ whiteSpace: 'pre-line', fontSize: '1.1rem', padding: 8, display: 'block', lineHeight: 1.5 }}>{item.deniedReason}</span>}
                                                                                                                placement="top"
                                                                                                                arrow
                                                                                                                PopperProps={{
                                                                                                                    modifiers: [
                                                                                                                        {
                                                                                                                            name: 'offset',
                                                                                                                            options: {
                                                                                                                                offset: [0, 8],
                                                                                                                            },
                                                                                                                        },
                                                                                                                    ],
                                                                                                                    sx: { '& .MuiTooltip-tooltip': { maxWidth: 400, padding: 2 } }
                                                                                                                }}
                                                                                                            >
                                                                                                                <span>
                                                                                                                    <InfoIcon style={{ color: '#1976d2', verticalAlign: 'middle', cursor: 'default' }} />
                                                                                                                </span>
                                                                                                            </Tooltip>
                                                                                                        ) : ''}
                                                                                                    </TableCell>
                                                                                                    <TableCell>
                                                                                                        {item.formData && (
                                                                                                            <InfoIcon
                                                                                                                onClick={() => {
                                                                                                                    SetOpenShowItemDetailsPopup(true);
                                                                                                                    SetSelectedItemFormDetails(item.formDataWithTitle);
                                                                                                                }}
                                                                                                                style={{ height: '30px', width: '24px', cursor: 'pointer', verticalAlign: 'middle' }}
                                                                                                            />
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            );
                                                                                        })}
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </Box>
                                                                        </Collapse>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        {visibleCount < filteredHistoricalRequests.length && (
                                            <Box display="flex" justifyContent="center" mt={2}>
                                                <Button variant="contained" onClick={() => setVisibleCount((prev) => prev + 50)}>
                                                    Load More
                                                </Button>
                                            </Box>
                                        )}
                                    </>
                                ) : (
                                    <label className='noDataFoundMessage'> No Historical Request Found</label>
                                )}
                            </div>
                        )
                    }
                </CardContent>
            </Card>
            <ShowNotes requestNotes={selectedH_RequestNotes} isOpenDialog={OpenShowNotePopup} handleCloseShowNotePopup={(isShowPopup) => { handleCloseShowNotePopup(isShowPopup) }} />
            {OpenShowItemDetailsPopup && (
                <Dialog open={OpenShowItemDetailsPopup} onClose={() => SetOpenShowItemDetailsPopup(false)}>
                    <DialogTitle>Item Form Details</DialogTitle>
                    <DialogContent>
                        {(() => {
                            let details = selectedItemFormDetails;
                            if (typeof details === 'string') {
                                try {
                                    details = JSON.parse(details);
                                } catch {}
                            }
                            const isDate = (val: string) => {
                                // ISO 8601 date check and not empty
                                return val && typeof val === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(val);
                            };
                            if (Array.isArray(details) && details.length > 0 && details[0].Key && details[0].Value !== undefined) {
                                return details.map((field: any, idx: number) => {
                                    let value = field.Value;
                                    if (isDate(value)) {
                                        value = dayjs(value).format('MM/DD/YYYY');
                                    }
                                    return (
                                        <div key={idx} style={{ marginBottom: '8px' }}>
                                            <b>{field.Key}:</b> {value}
                                        </div>
                                    );
                                });
                            } else if (typeof details === 'object' && details !== null) {
                                return Object.entries(details).map(([key, value], idx) => {
                                    if (typeof value === 'string' && isDate(value)) {
                                        value = dayjs(value).format('MM/DD/YYYY');
                                    }
                                    return (
                                        <div key={idx} style={{ marginBottom: '8px' }}>
                                            <b>{key}:</b> {String(value)}
                                        </div>
                                    );
                                });
                            } else {
                                return <div>No details available.</div>;
                            }
                        })()}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => SetOpenShowItemDetailsPopup(false)}>Close</Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    )
}

export default HistoricalRequests